import * as React from "react";
import type { SVGProps } from "react";
const SvgWeb3RankIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="web3_rank_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M170.667 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h682.666a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H170.667zm-42.667 128a42.667 42.667 0 0 1 42.667-42.666h682.666A42.667 42.667 0 0 1 896 213.333v597.334a42.667 42.667 0 0 1-42.667 42.666H170.667A42.667 42.667 0 0 1 128 810.667V213.333zM682.667 384A42.667 42.667 0 1 1 768 384v256a42.667 42.667 0 1 1-85.333 0V384zM512 426.667a42.667 42.667 0 0 0-42.667 42.666V640a42.667 42.667 0 1 0 85.334 0V469.333A42.667 42.667 0 0 0 512 426.667zM298.667 512A42.667 42.667 0 0 0 256 554.667V640a42.667 42.667 0 1 0 85.333 0v-85.333A42.667 42.667 0 0 0 298.667 512z"
    />
  </svg>
);
export default SvgWeb3RankIcon;
